export enum AuthorizationType {
	AUTENTIZACE = 'AUTENTIZACE',
	FCM = 'FCM',
	SMS = 'SMS',
}
